"use client"

import Link from "next/link"
import { Github, Twitter } from "lucide-react"
import { Button } from "@/components/ui/button"
import { Separator } from "@/components/ui/separator"

const footerLinks = {
  services: {
    title: "サービス",
    links: [
      { title: "AIコンテンツ生産工場", href: "/ai-factory" },
      { title: "CTO as a Service (技術アドバイザリー)", href: "/services?tab=consulting" },
      { title: "PoC開発", href: "/services?tab=development" },
      { title: "出向教育", href: "/services?tab=education" },
      { title: "DXリーダー育成", href: "/services?tab=education" },
    ],
  },
  company: {
    title: "企業情報",
    links: [
      { title: "会社概要", href: "/about" },
      { title: "Digital Pride Hiroshima", href: "/digital-pride" },
      { title: "ニュース", href: "/news" },
    ],
  },
  contact: {
    title: "お問い合わせ",
    links: [
      { title: "相談・問い合わせ", href: "/contact" },
      { title: "見学予約", href: "/contact?type=visit" },
      { title: "プライバシーポリシー", href: "/privacy" },
    ],
  },
}

const socialLinks = [
  {
    name: "X (Twitter)",
    href: "https://x.com/CodeFoxInc",
    icon: Twitter,
  },
  {
    name: "GitHub",
    href: "https://github.com/codefox-inc",
    icon: Github,
  },
]

export function Footer() {
  return (
    <footer className="bg-muted/30 border-t">
      <div className="container mx-auto px-4 py-12">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          {/* Company Info Section */}
          <div className="space-y-4">
            <Link href="/" className="flex items-center space-x-2">
              <span className="text-2xl font-bold">CodeFox</span>
            </Link>
            <p className="text-sm text-muted-foreground leading-relaxed">
              地域にデジタルの誇りを。
              <br />
              Digital Pride Hiroshima を拠点に、
              <br />
              文化翻訳型DXを実証・展示・教育。
            </p>
            
            {/* Social Links */}
            <div className="flex space-x-3 pt-2">
              {socialLinks.map((social) => {
                const Icon = social.icon
                return (
                  <Button
                    key={social.name}
                    variant="ghost"
                    size="icon"
                    className="h-9 w-9 hover:bg-primary/10 hover:text-primary"
                    asChild
                  >
                    <Link
                      href={social.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label={social.name}
                    >
                      <Icon className="h-4 w-4" />
                    </Link>
                  </Button>
                )
              })}
            </div>
          </div>

          {/* Services Column */}
          <div className="space-y-4">
            <h3 className="text-sm font-semibold text-foreground">
              {footerLinks.services.title}
            </h3>
            <ul className="space-y-3">
              {footerLinks.services.links.map((link) => (
                <li key={link.title}>
                  <Link
                    href={link.href}
                    className="text-sm text-muted-foreground hover:text-foreground transition-colors"
                  >
                    {link.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company & Contact Column */}
          <div className="space-y-6">
            {/* Company Info */}
            <div className="space-y-4">
              <h3 className="text-sm font-semibold text-foreground">
                {footerLinks.company.title}
              </h3>
              <ul className="space-y-3">
                {footerLinks.company.links.map((link) => (
                  <li key={link.href}>
                    <Link
                      href={link.href}
                      className="text-sm text-muted-foreground hover:text-foreground transition-colors"
                    >
                      {link.title}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Contact Links */}
            <div className="space-y-4">
              <h3 className="text-sm font-semibold text-foreground">
                {footerLinks.contact.title}
              </h3>
              <ul className="space-y-3">
                {footerLinks.contact.links.map((link) => (
                  <li key={link.href}>
                    <Link
                      href={link.href}
                      className="text-sm text-muted-foreground hover:text-foreground transition-colors"
                    >
                      {link.title}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        <Separator className="my-8" />

        {/* Footer Bottom */}
        <div className="flex justify-center items-center">
          <div className="text-sm text-muted-foreground">
            © 2026 CodeFox Inc. All rights reserved.
          </div>
        </div>
      </div>
    </footer>
  )
}
